import { IApplicationState } from '../../../types/redux';

/**
 * Выбирает регионы
 */
export const selectRegions = ({ regions }: IApplicationState) => regions;
